import React from 'react'
import { BookingsBox } from '../components/BookingsBox'
import { ChildrenBox } from '../components/ChildrenBox'
import { MedicalHistoryBox } from '../components/MedicalHistoryBox'
import { NavigationBar } from '../components/NavigationBar'
import { NumberedBox } from '../components/NumberedBox'
import { ProfileBox } from '../components/ProfileBox'
import { UpcomingEventsBox } from '../components/UpcomingEventsBox'
import { WelcomeBox } from '../components/WelcomeBox'

export function HomePage() {
  return (
    <div className="home-container" style={{ minHeight: '100vh' }}>
      {/* Navigation Bar */}
      <NavigationBar />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Welcome Box */}
          <NumberedBox number={1}>
            <WelcomeBox />
          </NumberedBox>

          {/* Profile Box */}
          <NumberedBox number={2} helpKey="profile">
            <ProfileBox />
          </NumberedBox>

          {/* Children Box */}
          <NumberedBox number={3} helpKey="children">
            <ChildrenBox />
          </NumberedBox>

          {/* Bookings Box */}
          <NumberedBox number={4} helpKey="bookings">
            <BookingsBox />
          </NumberedBox>

          {/* Medical History Box */}
          <NumberedBox number={5} helpKey="medicalHistory">
            <MedicalHistoryBox />
          </NumberedBox>

          {/* Upcoming Events Box */}
          <NumberedBox number={6} helpKey="upcomingEvents">
            <UpcomingEventsBox />
          </NumberedBox>
        </div>
      </main>
    </div>
  )
} 